import { render, staticRenderFns } from "./ViewerModule.vue?vue&type=template&id=c090b5ea&scoped=true&"
import script from "./ViewerModule.ts?vue&type=script&lang=ts&"
export * from "./ViewerModule.ts?vue&type=script&lang=ts&"
import style0 from "./ViewerModule.scss?vue&type=style&index=0&id=c090b5ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c090b5ea",
  null
  
)

export default component.exports